import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import PasswordRecoveryComponent from './password-recovery.component';
import PasswordRecoveryService from '../../services/password-recovery.service';

let PasswordRecoveryModule = angular
  .module('PasswordRecovery', [
    uiRouter
  ])
  .component('passwordRecovery', PasswordRecoveryComponent)  
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('passwordRecovery', {
      url: '/password-recovery/{token}',
      views: {
        'menu': "",
        'content': {
          component: 'passwordRecovery'
        }
      }
    })
  })
  .name;

export default PasswordRecoveryModule;



// WEBPACK FOOTER //
// ./src/app/pages/password-recovery/password-recovery.module.js